import { Toolbar, LibraryTabs, HubSwitch, Title, FiltersContext } from '@bpm-web-app/components';
import { Genres, GenresDetail } from '@bpm-web-app/components/pages';
import { useHubSwitch } from '@bpm-web-app/utils';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

export default function GenresPage({ title }: { title: string }) {
    const { query } = useRouter();
    const { category, genre } = query;
    const { hub } = useHubSwitch();
    const { resetFilters, updateFiltersFromQuery } = useContext(FiltersContext);

    useEffect(() => {
        resetFilters();
    }, [category, resetFilters]);

    useEffect(() => {
        updateFiltersFromQuery(query);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [genre, category]);

    return (
        <>
            <Title platform="download" title={title} />
            <Toolbar stickToHeader>
                <LibraryTabs />
                <HubSwitch />
            </Toolbar>
            {!category && !genre && <Genres />}
            {(category || genre) && <GenresDetail key={hub} category={category?.toString()} genre={genre?.toString()} />}
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Genres'
        }
    };
}
